<template>
  <v-card class="mb-3 pa-2" outlined v-if="show">
    <table class="caption" v-if="hasData">
      <tr v-for="(el, idx) in data" :key="idx">
        <th>{{ $t(el.name) }}:</th>
        <td>{{ el.value }}</td>
      </tr>
    </table>
  </v-card>
</template>

<script>
export default {
  name: 'settings-emergency-details',
  props: {
    data: {
      type: Array
    }
  },
  computed: {
    hasData: function () {
      return Array.isArray(this.data) && this.data.length > 0
    },
    show: function () {
      return this.data?.length > 0
    }
  }
}
</script>

<style scoped>
table th {text-align: left; vertical-align: top}
table td {padding-left: 10px}
</style>
